import React from 'react';
import PropTypes from 'prop-types';
import useStyles from 'isomorphic-style-loader/useStyles';

import { Dialog, Paper, IconButton } from '@material-ui/core';
import CloseIcon from '@material-ui/icons/Close';

// assets
import DialogWithCloseButtonStyles from './DialogWithCloseButton.scss';

export default function DialogWithCloseButton({ children, heading, onClose, isOpen, size }) {
  useStyles(DialogWithCloseButtonStyles);
  return (
    <Dialog
      className="dialog-with-close-button"
      open={isOpen}
      onClose={onClose}
      maxWidth={size}
      fullWidth
    >
      <Paper>
        <header className="dialog-with-close-button__header">
          {heading && <h2 className="dialog-with-close-button__heading">{heading}</h2>}
          <IconButton
            className="dialog-with-close-button__close-button"
            aria-label="close"
            onClick={onClose}
          >
            <CloseIcon />
          </IconButton>
        </header>
        <div className="dialog-with-close-button__content">{children}</div>
      </Paper>
    </Dialog>
  );
}

DialogWithCloseButton.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired,
  isOpen: PropTypes.bool,
  size: PropTypes.string,
  heading: PropTypes.string,
};

DialogWithCloseButton.defaultProps = {
  isOpen: false,
  size: 'sm',
  heading: null,
};
